const EquitySection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="section-header text-center mb-2">
                  <h2 className="text-uppercase">
                    Stock Trading Platform for{" "}
                    <span className="style2"> Online Equity Investment</span>
                  </h2>
                </div>
                <div className="about__content-inner">
                  <p className="text-justify">
                    We offer end-to-end equity solutions to individual Investors and
                    active Traders, serving them with quality advice on individual
                    stocks, sector trends, and investment strategy.
                  </p>

                  <h4>Research</h4>
                  <p>
                    Ethical advice driven by detailed equity research has been our
                    approach, and this has been a key reason in gaining clients’
                    trust. Research and investment ideas can be accessed by clients
                    either through designated dealers at the Investment Centre, Phone
                    Trade Agents, or the website. Clients can also opt for our push
                    services through which we make research and trading calls
                    available on email and SMS.
                  </p>

                  <h4>Advisory</h4>
                  <p>
                    The Value Picks & Investment Ideas (Recommended Stock Basket)
                    identified by the Fundamental Research Team are packaged and
                    communicated to our clients depending upon their profile by our
                    Equity Sales & Advisory Team.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EquitySection;
